module.exports = __webpack_public_path__ + "img/icon-home-active.fb904bbe.svg";